import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type ButtonProps = {
	type?: 'button'|'submit'|'reset';
	isText?: boolean;
	isDisabled?: boolean;
	className?: string;
}
const Button: React.FunctionComponent<ButtonProps> = ({type = 'button', isText = false, isDisabled, children, className}) => {
	return (
		<button
			type={type}
			className={classNames(
				styles.button,
				isText && styles.isText,
				isDisabled && styles.isDisabled,
				className
			)}
		>
			{children}
		</button>
	)
}

export default Button;
